export default __webpack_public_path__ + "static/media/gallery_01.4cff762e.jpg";